import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import bag from "../../Assets/Images/profile/defaultProfile.jpg";
import { ToastContainer, toast } from 'react-toastify';
import { CheckCircleOutlined } from '@ant-design/icons';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import CompLoaderBtn from '../Common/CompLoaderBtn';
import CompLoaderDt from '../Common/CompLoaderDt';

function CompDtSlider() {
    const { t } = useTranslation();
    const [componentId] = useState('compDtSlider');
    const [data, setData] = useState(null);

    const navigate = useNavigate();

    const [apiCalled, setApiCalled] = useState(false);

    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sort, setSort] = useState('createDate,DESC');
    const [paginationRowsPerPageOptions] = useState([1, 5, 10, 25, 50, 100]);
    const [totalRows, setTotalRows] = useState(0);

    const callCustomerDetails = (crmData) => {
        setApiCalled(true);
        let requestBody = {

        };
        const timeout = setTimeout(() => {
            let message = t('product.common-notification.will-be-develop');
            toast.warning(message, { autoClose: 1000 });
            setApiCalled(false);
            let redirectUrl = '/crm/' + crmData?.id;
            //window.location.href = redirectUrl;
            navigate(redirectUrl);
        }, 100);
    };

    React.useMemo(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            let currentSession = sessionStorage.getItem("currentSession");
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
            let ApiGateway = process.env.REACT_APP_API_URL;
            axios.get(ApiGateway + '/market-place/general/slider/find-and-list?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&sort=' + sort)
                .then(response => {
                    if (response.data?.isSucceed === true) {
                        setData(response.data?.payload);
                    }

                })
                .catch(error => {
                    console.error(error);
                });
        }
    }, [t, pageNumber, pageSize, sort]);

    const [deleteModal, setDeleteModal] = useState(false);
    const [recordId, setRecordId] = useState(false);

    const onGoToItemDetails = props => {
        //history.push('/product/' + props);
        //dispatch(mpMyCashDeskListApi(props));
    };

    const onBtnDeleteItem = props => {
        let message = 'Prohibited action!';
        toast.error(message, { autoClose: 1000 });
        console.log(props);
        setRecordId(props);
        //setDeleteModal(true);
    };

    const handleDeleteTask = () => {
        if (recordId) {
            //dispatch(mpMyCashDeskDeleteByIdApi({ cashDeskId: recordId }));
            //setDeleteModal(false);
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
        }
    };


    useEffect(() => {
        //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
    }, []);


    const handlePageChange = page => {
        setPageNumber(page - 1);
        //dispatch(mpMyCashDeskListApi(page - 1, pageSize, sort));
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setPageSize(newPerPage);
        //dispatch(mpMyCashDeskListApi(0, newPerPage, sort));
    }

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>{t('components.customers.comp-dt-customers.dt.th.title')}</span>,
            selector: row =>
                <div className="d-flex align-items-center mt-2">
                    <div className="flex-shrink-0 mb-2">
                        <img src={bag} width={28} height={28} alt="" className="avatar-xs rounded-circle" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                        <h6 className="mb-1"><span title={row?.name}>{row?.name}</span></h6>
                        <p className="text-muted mb-2"><span title={row?.title}>{row?.title}</span></p>
                    </div>
                    <div className="flex-shrink-0">
                    </div>
                </div>
            ,
            sortable: false,
            maxWidth: "425px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.customers.comp-dt-customers.dt.th.segment-label')}</span>,
            selector: row => <span title={row?.segment?.label}>{row?.segment?.label}</span>,
            sortable: false,
            maxWidth: "185px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.customers.comp-dt-customers.dt.th.location')}</span>,
            selector: row => <span title={row?.district?.name}>{row?.district?.city?.name} {'/'} {row?.district?.name}</span>,
            sortable: false,
            maxWidth: "225px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.customers.comp-dt-customers.dt.th.contact-identity-validation')}</span>,
            selector: row => <span>{row?.contactIdentityValidation === true ?
                <span className='text-success'><CheckCircleOutlined /></span>
                :
                <span className='text-danger'><CloseCircleOutlined /></span>
            }
            </span>,
            sortable: false,
            maxWidth: "180px"
        },
        {
            /*
            name: <span className='font-weight-bold fs-13'>{t('components.customers.comp-dt-customers.dt.th.details')}</span>,
            selector: row =>
                <>
                    <Button onClick={e => callCustomerDetails(row)} className={apiCalled === true ? 'btn btn-dark border-0 border w-100 disabled' : 'btn btn-dark border-0 border w-100'}>
                        <div className={apiCalled === true ? '' : 'd-none'}>
                            <CompLoaderBtn />
                        </div>
                        <span className={apiCalled !== true ? '' : 'd-none'}>{t('components.customers.comp-dt-customers.dt.td.button.details')}</span>
                    </Button>
                </>

            ,
            sortable: false,
            maxWidth: "275px"
            */
        },
    ];

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows((data !== null) ? data : []);
            setPending(false);
            setTotalRows((data !== null) ? data?.length : 0);
        }, 0);
        return () => clearTimeout(timeout);
    }, [data]);

    return (
        <React.Fragment>
            <ToastContainer />
            {data ? ((
                <DataTable
                    id={componentId}
                    columns={columns}
                    data={rows}
                    pagination={true}
                    paginationServer
                    onPageChange={page => setPageNumber(page)}
                    paginationPerPage={pageSize}
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={pending}
                    noDataComponent={t('data-table.label.no-data')}
                    paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                    paginationComponentOptions={{
                        rowsPerPageText: t('data-table.label.rows-per-page'),
                        rangeSeparatorText: t('data-table.label.out-of'),
                    }}
                />
            )) : (
                <Row>
                    <Col className={"col-md-12 text-center"}>
                        <CompLoaderDt />
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
export default CompDtSlider;